import React, {FC} from 'react';

interface MenuIconInterface {
    color: string;
    width?: string;
    onClick?: () => void;
}

export const MenuIcon: FC<MenuIconInterface> = ({
    color, 
    width = '100%', 
    onClick = () => {}
}) => {

    const style: object = {
        fill: color,
    }

    return (
    <svg 
        x="0px" 
        y="0px" 
        viewBox="0 0 1075 1066" 
        style={{width}}
        onClick={onClick}
    >
    <g>
        <path d="M943,275H129c-61.1,0-111-49.9-111-111v-3C18,99.9,67.9,50,129,50h814c61,0,111,49.9,111,111v3
            C1054,225.1,1004,275,943,275z"
            style={style}
        />
    </g>
    <g>
        <path d="M943,644H129c-61.1,0-111-50-111-111v-3c0-61,49.9-111,111-111h814c61,0,111,50,111,111v3
            C1054,594,1004,644,943,644z"
            style={style}
        />
    </g>
    <g>
        <path d="M943,1013H129c-61.1,0-111-50-111-111v-3c0-61,49.9-111,111-111h814c61,0,111,50,111,111v3
            C1054,963,1004,1013,943,1013z"
            style={style}
        />
    </g>
    </svg>
    )
}